import React, { useState, useEffect } from 'react';
import './Settings.css';
import { loadSettings, putUpdateSetting } from '../../store/Actions/ActionSetting';
import Emails from './EmailSettings';
import General from './GeneralSettings';
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar';
import { useSelectorCustom } from '../../components/general/general-component/abstruct-component/useSelectorCustom';
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang';
import SectionTopOfTable from '../../components/general/general-component/section-top-of-table/SectionTopOfTable';
import { UsePermissions, hasPermissions } from '../../components/general/general-component/abstruct-component/UsePermissions';
import CheckPermissions from '../../components/general/general-component/check-permissions';
import CheckLazyLoader from '../../components/general/general-component/check-lazy-loader';

function Settings() {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const settingss = hasPermissions([{ name: "settings" }], permissionss)
    const [activeSection, setActiveSection] = useState('e-mails');
    const { translate } = AbstructLang();
    const [isLoading, setLoading] = useState(false);
    const { dispatch, langLocal, navigate } = AbstructVar();
    const { settings, loadingSettings } = useSelectorCustom();

    const handleSectionClick = (sectionId) => {
        setActiveSection(sectionId);
    };

    const handleEdit = (settingName, value) => {
        dispatch(putUpdateSetting(settingName, value, setLoading));
    };

    useEffect(() => {
        dispatch(loadSettings());
    }, []);

    return (
        <CheckLazyLoader>
            <CheckPermissions array={settingss} loadingMainPermission={loadingMainPermission} >
                <main>
                    <div className='div_table margin_main shadow_main' dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                        <SectionTopOfTable langLocal={langLocal} title={translate('General_Settings')} />
                        <div className='all_setting'>
                            <div className='head_with_title'>
                                <span className={langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} onClick={() => handleSectionClick('e-mails')}>{translate('e-mails')}</span>
                                <span className={langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} onClick={() => handleSectionClick('general')}>{translate('general')}</span>
                            </div>
                            {activeSection === 'e-mails' && (
                                <Emails
                                    translate={translate}
                                    settings={settings}
                                    loadingSettings={loadingSettings}
                                    handleEdit={handleEdit}
                                />
                            )}
                            {activeSection === 'general' && (
                                <General
                                    translate={translate}
                                    settings={settings}
                                    loadingSettings={loadingSettings}
                                    handleEdit={handleEdit}
                                    isLoading={isLoading}
                                />
                            )}
                        </div>
                    </div>
                </main>
            </CheckPermissions>


        </CheckLazyLoader>
    );
}

export default Settings;